import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'

export const passwordMatchValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  let password = control.get('_password')
  let confirmPassword = control.get('_confirmPassword')
  if (password && confirmPassword && password?.value != confirmPassword?.value) {
    return {
      passwordMatchError: true,
    }
  }
  return null
}
